RivalIQ.module('export.models', function (models, App, Backbone, Marionette, $, _, moment) {

    'use strict';

    const Report = models.Report = Backbone.Model.extend({

        initialize: function (attributes, options) {
            const me = this;
            options = options || {};

            me.config = options.dashboardModel;

            if (options.pollStatus) {
                me.pollStatus();
            }

            me.on('change:export_status_id', function () {

                if (me.isFailed()) {
                    me.off('change:export_status_id');
                    me.onFailed();
                }
            }, me);
        },

        onFailed: function () {
            const me = this;
            RivalIQ.execute('alert:danger', `We had an issue exporting your ${me.get('format')}.  Please try again.`);
        },

        getTitle: function () {
            const me = this;

            if (me.config) {
                return me.config.getTitle(me.get('format'));
            }

            return me.get('title');
        },

        dialogRequired: function () {
            return true;
        },

        getExportPage: function () {
            const me = this;
            return me.config.getExportPathObject(me.get('format'));
        },

        getReportType: function () {
            const me = this;
            return _.result(me.config, 'reportType');
        },

        getOrientation: function () {
            const me = this;
            return me.config.getExportOrientation(me.get('format'));
        },

        getFiletypes: function () {
            const me = this;
            return me.config.getExportFormats();
        },

        save: function () {
            const me = this;

            RivalIQ.export.models.factories[me.get('format')](me);

            return Backbone.Model.prototype.save.call(me, {}, {
                success: _.bind(me.trigger, me, 'save:succeeded'),
                error: _.bind(me.trigger, me, 'save:failed')
            });
        },

        isPPT: function () {
            const me = this;
            return me.get('format') === RivalIQ.export.format.PPT;
        },

        getAction: function () {
            const me = this;
            return RivalIQ.export.data.actions.get(me.get('data').spec.action);
        },

        getIcon: function () {
            const me = this;
            return RivalIQ.export.data.filetypes.get(me.get('export_type_id')).get('icon');
        },

        getDownloadPath: function () {
            const me = this;
            return `/r/${me.get('uuid')}`;
        },

        pollStatus: function () {
            const me = this;
            if (me.isBuilding()) {
                $.get(`/api/exportStatus?uuid=${me.get('uuid')}`).done(function (resp) {
                    me.set('export_status_id', _.head(resp));
                });

                me._pollTimeout = setTimeout(_.bind(me.pollStatus, me), 1000);
            }
        },

        isBuilding: function () {
            const me = this;
            return _.includes([RivalIQ.export.enums.status.PENDING, RivalIQ.export.enums.status.IN_PROGRESS], me.get('export_status_id'));
        },

        isFailed: function () {
            const me = this;
            return me.get('export_status_id') === RivalIQ.export.enums.status.FAILED;
        },

        isDone: function () {
            const me = this;
            return me.get('export_status_id') === RivalIQ.export.enums.status.SUCCESS;
        },

        // TODO data key is a postgres detail and should not be exposed to the
        // client
        isScheduled: function () {
            const me = this;
            return me.get('data').spec.action === RivalIQ.export.type.SCHEDULE;
        },

        parse: function (attrs) {
            attrs.created_at = moment.utc(attrs.created_at);
            return attrs;
        },

        trackExport: function () {
            const me = this;
            const tracking = me.config.getExportTracking(me.action, me.get('format'));
            RivalIQ.execute('tracking:push:dynamic', tracking);
        }
    });

    Report.build = function (action, format, dashboardModel) {

        const exportModels = [
            RivalIQ.export.models.DownloadedReport,
            RivalIQ.export.models.EmailedReport,
            RivalIQ.export.models.ScheduledReport
        ];

        const Model = _.find(exportModels, {
            action: action
        });

        // Export attributes. Format and email are defaults and can be
        // changed by the user
        const attributes = _.extend({
            format: format || RivalIQ.export.format.PPT,
            email: dashboardModel.getProp('email')
        }, dashboardModel.getReportAttributes(format));

        const options = {
            dashboardModel: dashboardModel
        };

        return new Model(attributes, options);
    };
}, window.moment);
